exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-horizontal-scroll-type[data-v-4051c291]{height:1px;position:absolute;opacity:0;overflow-x:scroll;width:1px}.ebx-horizontal-scroll-type__scroll[data-v-4051c291]{height:1px;width:2px}", ""]);
